import { Outlet } from "react-router-dom";

const TechnicianDashboard = () => {
  return <Outlet />;
};

export default TechnicianDashboard;
